import {useCallback, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {TextEditorButtons} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Mobile/TextEditor/TextEditorButtons';
import {menuMappingKeys} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {FontsMobile} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/Dropdown/FontsMobile';
import {TextSize} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextSize/TextSize';
import {TextFormat} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/TextFormat/TextFormat';
import {SpacingHeight} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Mobile/Contents/SpacingHeight/SpacingHeight';
import {TextColorPicker} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/ColorPicker/TextColorPicker';
import {UyoEditor} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Mobile/UyoEditor/UyoEditor';

export const MWEditorDrawerContent = ({
  activeMenu,
  showMenu,
  scrollToTop,
  setActiveMenu,
  setShowMenu,
  isPhotoDrawer = false,
}) => {
  if (!showMenu) return null;

  const {canvas, activeObjects} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const selectFirstTextObject = useCallback(() => {
    if (!activeObjects || activeObjects.length === 0) {
      const textObjects = canvas.getObjects().filter((obj) => obj.type === 'textbox');
      if (textObjects.length > 0) {
        canvas.setActiveObject(textObjects[0]);
        canvas.renderAll();
        return true;
      }
    }
    return false;
  }, [canvas, activeObjects]);

  const onKeyboardButtonClick = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {textAreaOpen: true},
    });
  }, []);

  const onClickMenu = useCallback(
    (newMenu) => () => {
      selectFirstTextObject();
      setShowMenu(true);
      setActiveMenu(newMenu);
    },
    [selectFirstTextObject]
  );

  if (activeMenu === 'text') {
    return (
      <TextEditorButtons
        activeMenu={activeMenu}
        onClickMenu={onClickMenu}
        onKeyboardButtonClick={onKeyboardButtonClick}
      />
    );
  }
  if (activeMenu === menuMappingKeys.FONT_STYLE) {
    return <FontsMobile />;
  }
  if (activeMenu === menuMappingKeys.FONT_SIZE) {
    return <TextSize />;
  }
  if (activeMenu === menuMappingKeys.TEXT_FORMAT) {
    return <TextFormat />;
  }
  if (activeMenu === menuMappingKeys.SPACING) {
    return <SpacingHeight />;
  }
  if (activeMenu === menuMappingKeys.COLOR) {
    return <TextColorPicker isTextColorPicker />;
  }
  if (isPhotoDrawer) {
    return (
      <UyoEditor
        activeMenu={activeMenu}
        scrollToTop={scrollToTop}
        setActiveMenu={setActiveMenu}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        noContentBase
      />
    );
  }

  return null;
};
